import { dateDiff, formatDate } from '../../../../app/helpers';
import moment from 'moment';
moment.locale('pt-br');

(function () {
  'use srict';

  new Vue({
    el: '[data-vue=lot-header]',
    methods: {
      formatDrawDate: (drawDate) => {
        if (!drawDate) {
          return 'A Definir';
        } else {
          const today = moment().endOf('day');
          const diff = dateDiff(new Date(drawDate), today);

          switch (diff) {
            case 0:
              return 'Hoje';
            case 1:
              return 'Amanhã';
            default:
              return formatDate(drawDate, 'DD/MM')
          }
        }
      }
    },
    mounted () {
      const getApp = document.querySelector('[data-app]')
      const resultApp = getApp.getAttribute('data-app')

      if (resultApp !== 'tele-sena') {
        const drawDateEl = document.querySelector('[data-draw-date]');
        const date = drawDateEl.getAttribute('data-draw-date')
        drawDateEl.innerHTML = this.formatDrawDate(date);
      }
    }
  });
})(window);
